import NetworkCall from "network/networkCall";
import Request from "network/request";

export class ClientReports {
  static async getEmbed(clientId, reportType) {
    return NetworkCall.fetch(
      Request.v2.getClientReportEmbed(clientId, reportType),
      false,
      false,
    );
  }
}
